
    import { mapState } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faEllipsisVertical as farEllipsisVertical,
    } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical';
    import JobDate from '@/components/Job/JobDate';
    import JobStatus from '@/components/Job/JobStatus';
    import JobSave from '@/components/Job/JobSave';
    import JobViewMixin from '@/components/JobView/Mixins/JobViewMixin';

    export default {
        name: 'JobViewStatusBar',

        components: {
            JobDate,
            JobStatus,
            JobSave,
            FontAwesomeIcon,
        },

        mixins: [JobViewMixin],

        data() {
            return {
                icons: {
                    farEllipsisVertical,
                },
            };
        },

        computed: {
            ...mapState({
                $_isApplyEnabled: state => state.job.is_apply_enabled,
                $_jobApplication: state => state.jobApplication,
            }),
        },
    };
